import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  SmartToy as AssistantIcon,
  Work as ProjectsIcon,
  Phone as CallLogsIcon,
  AccountCircle as AccountIcon,
  FolderOpen as FilesIcon,
  Article as ContentIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const drawerWidth = 260;

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Assistant', icon: <AssistantIcon />, path: '/assistant' },
  { text: 'Projects', icon: <ProjectsIcon />, path: '/projects' },
  { text: 'Call Logs', icon: <CallLogsIcon />, path: '/call-logs' },
  { text: 'Account', icon: <AccountIcon />, path: '/account' },
  { text: 'Content', icon: <ContentIcon />, path: '/content' },
  { text: 'Files', icon: <FilesIcon />, path: '/files' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'background.paper',
          borderRight: '1px solid rgba(255, 255, 255, 0.12)',
        },
      }}
    >
      <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src="https://atlasintelgroup-logos.s3.amazonaws.com/logo-64x64.svg"
          alt="Atlas Intelligence"
          sx={{
            height: 32,
            width: 'auto',
            objectFit: 'contain',
          }}
        />
        <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
          {user?.email || 'User'}
        </Typography>
      </Toolbar>
      <Divider />

      <List sx={{ flex: 1 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider />

      <Box sx={{ p: 2 }}>
        <ListItemButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            logout();
          }}
          sx={{
            borderRadius: 1,
            '&:hover': {
              backgroundColor: 'error.dark',
            },
          }}
        >
          <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </Box>
    </Drawer>
  );
}
